// extracted by mini-css-extract-plugin
module.exports = {"titleItem":"infoItem_titleItem__LkOwH","infoItem":"infoItem_infoItem__2UIIc","titleItemText":"infoItem_titleItemText__1_e-5"};